import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      if (!hash.includes('session_id=')) {
        navigate('/login');
        return;
      }

      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        navigate('/dashboard', { 
          replace: true,
          state: { user: response.data.user }
        });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E5EBDD]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#8EAA97] border-t-[#1A4331] rounded-full animate-spin mx-auto"></div>
        <p className="mt-4 text-[#5C665C] font-medium">Setting up your garden...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
